var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.435 1.238l8.342 8.312a.638.638 0 0 1 0 .862l-8.337 8.312a.551.551 0 0 1-.862 0l-.36-.36a.649.649 0 0 1 0-.862l6.685-6.66H8.717a.61.61 0 0 1-.608-.608v-.506a.61.61 0 0 1 .608-.609h14.186l-6.69-6.66a.66.66 0 0 1 0-.86l.36-.36a.609.609 0 0 1 .862 0zM2.433.25h6.69a.61.61 0 0 1 .608.608v.406a.61.61 0 0 1-.608.608h-6.69a.822.822 0 0 0-.811.81V17.28c0 .446.378.811.81.811h6.69a.61.61 0 0 1 .609.608v.406a.61.61 0 0 1-.608.608h-6.69A2.433 2.433 0 0 1 0 17.279V2.683A2.433 2.433 0 0 1 2.433.25z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/signout.c8d6c4d2f5ca9411116e7ccc4c9d628f.svg";
export { ForwardRef as ReactComponent };